import axios from "axios";
import Jsona from "jsona";
import Vue from "vue";
import contentDisposition from "content-disposition";
import { eventBus } from "@/components/competences/event-bus";
import { axiosError } from "@/js/services/error/axiosError";

const state = {
  apiUrl: "",
  loading: false,
  competenceCards: [],
  appliedFilters: {},
  settingsContext: {},
  sortDirection: "ascending"
};

const dataFormatter = new Jsona();

const client = axios.create();

client.interceptors.request.use(config => {
  var token = window.localStorage.getItem("accessToken");
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }

  return config;
});

client.interceptors.request.use(function(response) {
  state.loading = true;
  return response;
});

client.interceptors.response.use(
  function(response) {
    state.loading = false;
    return response;
  },
  function(error) {
    state.loading = false;

    eventBus.send("error", axiosError.create(error));

    return Promise.reject(error);
  }
);

const getters = {
  loading: state => {
    return state.loading;
  },
  appliedFilters: state => {
    return state.appliedFilters;
  },
  sortDirection: state => {
    return state.sortDirection;
  },
  competenceCards: state => {
    let competenceCards = state.competenceCards;
    if (
      state.appliedFilters &&
      state.appliedFilters.name &&
      state.appliedFilters.name !== ""
    ) {
      competenceCards = competenceCards.filter(card =>
        `${card.basicInformation.firstName.toLowerCase() +
          " " +
          card.basicInformation.surName.toLowerCase()}`.includes(
          state.appliedFilters.name.toLowerCase()
        )
      );
    }
    if (state.appliedFilters && state.appliedFilters.competence) {
      competenceCards = competenceCards.filter(card =>
        card.competences.find(
          competence => competence.id === state.appliedFilters.competence.id
        )
      );
    }
    if (state.appliedFilters && state.appliedFilters.course) {
      competenceCards = competenceCards.filter(card =>
        card.courses.find(
          course =>
            course.category &&
            course.category.id === state.appliedFilters.course.id
        )
      );
    }
    if (state.appliedFilters && state.appliedFilters.workplace) {
      competenceCards = competenceCards.filter(
        card =>
          card.basicInformation.workplace.id ===
          state.appliedFilters.workplace.id
      );
    }
    if (state.appliedFilters && state.appliedFilters.expiring) {
      competenceCards = competenceCards.filter(card => {
        if (
          card.courses.find(
            course =>
              (course.status === "Expired" &&
                course.expirationHandleMode === "Unhandled") ||
              (course.status === "Expiring" &&
                course.expirationHandleMode === "Unhandled")
          )
        ) {
          if (state.appliedFilters && state.appliedFilters.course) {
            if (
              card.courses.find(
                course =>
                  course.category &&
                  course.category.id === state.appliedFilters.course.id &&
                  ((course.status === "Expired" &&
                    course.expirationHandleMode === "Unhandled") ||
                    (course.status === "Expiring" &&
                      course.expirationHandleMode === "Unhandled"))
              )
            ) {
              return card;
            }
          }
          else {
            return card;
          }
        }
      });
    }
    return competenceCards;
  },
  competenceCardRows: (state, getters) => {
    let cardRows = getters.competenceCards.map(card => ({
      id: card.id,
      items: [
        {
          variant: "label-value",
          label: "Namn",
          value:
            card.basicInformation.firstName +
            " " +
            card.basicInformation.surName
        },
        {
          variant: "label-value",
          label: "Anställd som",
          value: card.basicInformation.role
            ? card.basicInformation.role
            : "&nbsp;"
        },
        {
          variant: "custom",
          label: "&nbsp;",
          value: card.courses.find(
            c =>
              (c.status === "Expired" &&
                c.expirationHandleMode === "Unhandled") ||
              (c.status === "Expiring" &&
                c.expirationHandleMode === "Unhandled")
          )
            ? "<div class=\"c-notify-pill\" title=\"Har kurs/intyg som snart löper ut\"><span>Har kurs/intyg som snart löper ut</span></div>"
            : "&nbsp;"
        },
        {
          variant: "router-link",
          label: "Visa/ändra",
          value: "/competence-card/" + card.id,
          cssClasses: "t-text-align-right"
        }
      ]
    }));
    if (state.appliedFilters && state.sortDirection === "descending") {
      return cardRows.sort((a, b) =>
        a.items.find(i => i.label === "Namn").value <
        b.items.find(i => i.label === "Namn").value
          ? 1
          : -1
      );
    }
    else {
      return cardRows.sort((a, b) =>
        a.items.find(i => i.label === "Namn").value >
        b.items.find(i => i.label === "Namn").value
          ? 1
          : -1
      );
    }
  },
  competenceCard: state => (id = "0") => {
    let competenceCard = state.competenceCards.find(card => card.id === id);
    if (!competenceCard) return {};
    return competenceCard;
  },
  competenceRows: (state, getters) => (competenceCardId = "0") => {
    let competenceCard = getters.competenceCard(competenceCardId);
    if (!competenceCard || !competenceCard.competences) return [];
    let rows = competenceCard.competences.map(competence => ({
      id: competence.id,
      printOptionClass: competence.printOption === "Display" ? "" : "hidden",
      items: [
        {
          variant: "label-value",
          label: "Kompetens",
          value: competence.category + ": " + competence.name
        },
        {
          variant: "label-value",
          label: "Nivå",
          value: competence.level ? competence.level : "&nbsp;"
        },
        {
          variant: "label-value",
          label: "Notering",
          value: competence.note ? competence.note : "&nbsp;"
        }
      ]
    }));
    return rows.sort((a, b) =>
      a.items.find(i => i.label === "Kompetens").value >
      b.items.find(i => i.label === "Kompetens").value
        ? 1
        : -1
    );
  },
  competences: (state, getters) => (id = "0") => {
    let competences = [];
    let competenceCard = getters.competenceCard(id);
    if (
      competenceCard &&
      competenceCard.competences &&
      competenceCard.competences.length > 0
    ) {
      return competences;
    }
  },
  competence: (state, getters) => (
    competenceCardId = "0",
    competenceId = "0"
  ) => {
    let competenceCard = getters.competenceCard(competenceCardId);
    if (!competenceCard || !competenceCard.competences) return {};
    return competenceCard.competences.find(
      competence => competence.id === competenceId
    );
  },
  courseRows: (state, getters) => (competenceCardId = "0") => {
    let competenceCard = getters.competenceCard(competenceCardId);
    if (!competenceCard || !competenceCard.courses) return [];
    let rows = competenceCard.courses.map(course => ({
      id: course.id,
      printOptionClass: course.printOption === "Display" ? "" : "hidden",
      items: [
        {
          variant: "label-value",
          label: "Kategori",
          value:
            course.category && course.category.name
              ? course.category.group + ": " + course.category.name
              : "&nbsp;"
        },
        {
          variant: "label-value",
          label: "Namn",
          value: course.name ? course.name : "&nbsp;"
        },
        {
          variant: "custom",
          label: "&nbsp;",
          value:
            course.status === "Expired" &&
            course.expirationHandleMode === "Unhandled"
              ? "<div class=\"c-notify-pill\" title=\"Löpt ut\"><span>Löpt ut</span></div>"
              : course.status === "Expiring" &&
                course.expirationHandleMode === "Unhandled"
                ? "<div class=\"c-notify-pill\" title=\"Löper snart ut\"><span>Löper snart ut</span></div>"
                : "&nbsp;"
        },
        {
          variant: "label-value",
          label: "Typ",
          value: course.courseType
            ? course.courseType === "Course"
              ? "Kurs"
              : "Intyg/certifikat"
            : "&nbsp;"
        },
        {
          variant: "label-value",
          label:
            course.certificationLink === "" ||
            course.certificationLink === undefined
              ? ""
              : "Kursbevis",
          value:
            course.certificationLink === "" ||
            course.certificationLink === undefined
              ? ""
              : "<span class=\"c-icon-link centered\"><a href=\"" +
                course.certificationLink +
                "\" target=\"_blank\" ><span aria-hidden=\"true\" class=\"c-icon  c-icon--link c-icon-link_icon\"><svg><use xlink:href=\"#icon-document\"></use></svg></span></a><span><a href=\"" +
                course.certificationLink +
                "\" class=\"c-icon-link__text\"></a></span></span>"
        },
        {
          variant: "label-value",
          label: "Kurs-/utfärdandedatum",
          value: course.issued
            ? `<span class="t-nowrap">${new Date(
              course.issued
            ).toLocaleDateString("sv-SE")}</span>`
            : ""
        },
        {
          variant: "label-value",
          label: "Giltig till",
          value: course.expires
            ? `<span class="t-nowrap">${new Date(
              course.expires
            ).toLocaleDateString("sv-SE")}</span>`
            : "Tills vidare"
        }
      ]
    }));
    return rows.sort((a, b) => {
      if (
        a.items.find(i => i.label === "Kategori").value >
        b.items.find(i => i.label === "Kategori").value
      ) {
        return 1;
      }
      if (
        a.items.find(i => i.label === "Kategori").value <
        b.items.find(i => i.label === "Kategori").value
      ) {
        return -1;
      }
      if (
        a.items.find(i => i.label === "Namn").value >
        b.items.find(i => i.label === "Namn").value
      ) {
        return 1;
      }
      if (
        a.items.find(i => i.label === "Namn").value <
        b.items.find(i => i.label === "Namn").value
      ) {
        return -1;
      }
    });
  },
  courses: (state, getters) => (id = "0") => {
    let courses = [];
    let competenceCard = getters.competenceCard(id);
    if (
      competenceCard &&
      competenceCard.courses &&
      competenceCard.courses.length > 0
    ) {
      return courses;
    }
  },
  course: (state, getters) => (competenceCardId = "0", courseId = "0") => {
    let competenceCard = getters.competenceCard(competenceCardId);
    if (!competenceCard || !competenceCard.courses) return {};
    return competenceCard.courses.find(course => course.id === courseId);
  },
  workplaceOptions: state => {
    if (!state.settingsContext || !state.settingsContext.workplaces) {
      return [];
    }
    let items = state.settingsContext.workplaces.map(option => ({
      id: option.id,
      group: option.type,
      name: option.name
    }));
    let options = [
      {
        label: "Arbetsställe",
        items: items
      }
    ];
    return options;
  },
  workplaceFilterOptions: state => {
    let filterOptions = [];
    state.competenceCards.map(card => {
      if (
        card.basicInformation &&
        card.basicInformation.workplace &&
        !filterOptions.find(
          option => option.id === card.basicInformation.workplace.id
        )
      ) {
        filterOptions.push({
          id: card.basicInformation.workplace.id,
          group: "Workplace",
          name: card.basicInformation.workplace.attributes.name
        });
      }
    });
    return [
      {
        label: "Arbetsställe",
        items: filterOptions
      }
    ];
  },
  competenceOptions: (state, getters) => {
    const groups = [
      ...new Set(getters.competenceOptionsRaw.map(item => item.group))
    ];
    if (!groups) return [];
    let options = groups.sort().map(group => {
      return {
        label: group,
        items: getters.competenceOptionsRaw
          .filter(option => option.group === group)
          .sort((a, b) => (a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0))
      };
    });
    return options;
  },
  competenceFilterOptions: state => {
    let filterOptions = [];
    state.competenceCards.map(card =>
      card.competences.map(competence => {
        if (!filterOptions.find(option => option.id === competence.id)) {
          filterOptions.push({
            id: competence.id,
            group: competence.category,
            name: competence.name
          });
        }
      })
    );
    const groups = [...new Set(filterOptions.map(item => item.group))];
    if (!groups) return [];
    return groups.sort().map(group => {
      return {
        label: group,
        items: filterOptions
          .filter(option => option.group === group)
          .sort((a, b) => (a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0))
      };
    });
  },
  competenceLevelOptions: state => {
    if (!state.settingsContext || !state.settingsContext.competenceLevels) {
      return [];
    }
    let items = state.settingsContext.competenceLevels.map(option => ({
      id: option.id,
      group: option.type,
      name: option.name
    }));
    let options = [
      {
        label: "Nivå",
        items: items
      }
    ];
    return options;
  },
  courseOptions: (state, getters) => {
    const groups = [
      ...new Set(getters.courseOptionsRaw.map(item => item.group))
    ];
    if (!groups) return [];
    let options = groups.sort().map(group => {
      return {
        label: group,
        items: getters.courseOptionsRaw
          .filter(option => option.group === group)
          .sort((a, b) => (a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0))
      };
    });
    return options;
  },
  competenceOptionsRaw: () => {
    if (!state.settingsContext || !state.settingsContext.competences) {
      return [];
    }
    let items = state.settingsContext.competences.map(option => ({
      id: option.id,
      group: option.category,
      name: option.name
    }));
    return items;
  },
  courseFilterOptions: state => {
    let filterOptions = [];
    state.competenceCards.map(card =>
      card.courses.map(course => {
        if (
          course.category &&
          !filterOptions.find(option => option.id === course.category.id)
        ) {
          filterOptions.push({
            id: course.category.id,
            group: course.category.group,
            name: course.category.name
          });
        }
      })
    );
    const groups = [...new Set(filterOptions.map(item => item.group))];
    if (!groups) return [];
    return groups.sort().map(group => {
      return {
        label: group,
        items: filterOptions
          .filter(option => option.group === group)
          .sort((a, b) => (a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0))
      };
    });
  },
  courseOptionsRaw: () => {
    if (!state.settingsContext || !state.settingsContext.courseCategories) {
      return [];
    }
    let items = state.settingsContext.courseCategories.map(option => ({
      id: option.id,
      group: option.group,
      name: option.name
    }));
    return items;
  }
};

const actions = {
  setAppData({ commit }, { apiUrl }) {
    if (state.apiUrl) return;
    commit("setAppData", { apiUrl });
  },
  setSettingsContext({ state, commit }) {
    return new Promise(resolve => {
      if (
        state.settingsContext &&
        Object.keys(state.settingsContext).length > 0
      ) {
        return;
      }
      client
        .get(state.apiUrl + "/api/CompetenceCards/SettingsContext")
        .then(response => {
          if (response && response.data) {
            let formattedResponse = dataFormatter.deserialize(response.data);
            commit("setSettingsContext", formattedResponse);
            resolve();
          }
        });
    });
  },
  fetchCompetenceCards({ state, commit }) {
    return new Promise(resolve => {
      client.get(state.apiUrl + "/api/CompetenceCards").then(response => {
        if (response && response.data) {
          let formattedResponse = dataFormatter.deserialize(response.data);
          commit("setCompetenceCards", formattedResponse);
          resolve();
        }
      });
    });
  },
  fetchCompetenceCard({ dispatch, getters }, { id }) {
    let competenceCard = getters.competenceCard(id);
    if (competenceCard && competenceCard.id === id) {
      return;
    }
    dispatch("fetchCompetenceCards");
  },
  addCompetenceCard({ commit }, competenceCard) {
    return new Promise((resolve, reject) => {
      client
        .post(state.apiUrl + "/api/CompetenceCards", competenceCard)
        .then(response => {
          if (response && response.data) {
            const formattedResponse = dataFormatter.deserialize(response.data);
            commit("addCompetenceCard", formattedResponse);
            resolve(formattedResponse.id);
          }
        })
        .catch(reject);
    });
  },
  editCompetenceCard(
    { commit },
    {
      id,
      firstName,
      surName,
      personalIdentityNumber,
      employeeNumber,
      employmentDate,
      email,
      role,
      drivingLicense,
      experience,
      education
    }
  ) {
    return new Promise(resolve => {
      client
        .patch(state.apiUrl + "/api/CompetenceCards/" + id, {
          firstName,
          surName,
          personalIdentityNumber,
          employeeNumber,
          employmentDate,
          email,
          role,
          drivingLicense,
          experience,
          education
        })
        .then(response => {
          if (response && response.data) {
            commit("editCompetenceCard", {
              id: id,
              updated: dataFormatter.deserialize(response.data)
            });
            resolve();
          }
        });
    });
  },
  generatePdf({ state }, competenceCardId) {
    if (!competenceCardId) return;
    return new Promise(resolve => {
      client
        .get(
          state.apiUrl +
            "/api/CompetenceCards/" +
            competenceCardId +
            "/Export/Pdf",
          { responseType: "arraybuffer" }
        )
        .then(response => {
          if (response && response.data) {
            const disposition = response.request.getResponseHeader(
              "Content-Disposition"
            );
            const parsedDisponition = contentDisposition.parse(disposition);
            const filename =
              parsedDisponition.parameters.filename || "Kompetenskort.pdf";

            let isIE = /* @cc_on!@ */ false || !!document.documentMode;
            let file = new Blob([response.data], { type: "application/pdf" });
            if (isIE) {
              window.navigator.msSaveOrOpenBlob(file, filename);
            }
            else {
              const fileURL = URL.createObjectURL(file);
              const link = document.createElement("a");
              link.href = fileURL;
              link.download = filename;
              link.click();
            }
            resolve();
          }
        });
    });
  },
  /* --- Competences --- */
  createCompetence(
    { state, commit },
    { competenceCardId, category, name, level, note, printOption }
  ) {
    return new Promise(resolve => {
      client
        .post(
          state.apiUrl +
            "/api/CompetenceCards/" +
            competenceCardId +
            "/Competences",
          { category, name, level, note, printOption }
        )
        .then(response => {
          if (response && response.data) {
            const competence = response.data;
            commit("addCompetence", {
              competenceCardId: competenceCardId,
              competence: competence
            });

            commit("addCustomCompetence", {
              id: competence.id,
              category: competence.category,
              name: competence.name
            });

            resolve(competence.id);
          }
        });
    });
  },
  editCompetence(
    { commit },
    { competenceCardId, competenceId, level, note, printOption }
  ) {
    return new Promise(resolve => {
      client
        .patch(
          state.apiUrl +
            "/api/CompetenceCards/" +
            competenceCardId +
            "/Competences/" +
            encodeURIComponent(competenceId),
          { level, note, printOption }
        )
        .then(response => {
          if (response && response.data) {
            commit("editCompetence", {
              competenceCardId,
              competenceId,
              name,
              level,
              note,
              printOption
            });
            resolve();
          }
        });
    });
  },
  deleteCompetence({ commit }, { competenceCardId, competenceId }) {
    return new Promise(resolve => {
      client
        .delete(
          state.apiUrl +
            "/api/CompetenceCards/" +
            competenceCardId +
            "/Competences/" +
            encodeURIComponent(competenceId)
        )
        .then(response => {
          if (response && response.status === 200) {
            commit("deleteCompetence", { competenceCardId, competenceId });
            resolve();
          }
        });
    });
  },
  /* --- Courses --- */
  addCourse(
    { state, commit },
    {
      competenceCardId,
      courseType,
      categoryGroup,
      category,
      name,
      issuer,
      issued,
      expires,
      printOption,
      certificationLink
    }
  ) {
    return new Promise(resolve => {
      client
        .post(
          state.apiUrl +
            "/api/CompetenceCards/" +
            competenceCardId +
            "/Courses",
          {
            courseType,
            categoryGroup,
            category,
            name,
            issuer,
            issued,
            expires,
            printOption,
            certificationLink
          }
        )
        .then(response => {
          if (response && response.data) {
            const course = dataFormatter.deserialize(response.data);
            commit("addCourse", {
              competenceCardId: competenceCardId,
              course: course
            });

            commit("addCourseCategory", course.category);

            resolve(response.data.data.id);
          }
        });
    });
  },
  editCourse(
    { commit },
    {
      competenceCardId,
      courseId,
      courseType,
      categoryGroup,
      category,
      name,
      issuer,
      issued,
      expires,
      expirationHandleMode,
      printOption,
      certificationLink
    }
  ) {
    return new Promise(resolve => {
      client
        .patch(
          `${state.apiUrl}/api/CompetenceCards/${competenceCardId}/Courses/${courseId}`,
          {
            courseType,
            categoryGroup,
            category,
            name,
            issuer,
            issued,
            expires,
            expirationHandleMode,
            printOption,
            certificationLink
          }
        )
        .then(response => {
          if (response && response.data) {
            const course = dataFormatter.deserialize(response.data);

            commit("editCourse", {
              competenceCardId: competenceCardId,
              courseId: courseId,
              updated: course
            });

            commit("addCourseCategory", course.category);

            resolve(course);
          }
        });
    });
  },
  deleteCourse({ commit }, { competenceCardId, courseId }) {
    return new Promise(resolve => {
      client
        .delete(
          state.apiUrl +
            "/api/CompetenceCards/" +
            competenceCardId +
            "/Courses/" +
            courseId
        )
        .then(response => {
          if (response && response.status === 200) {
            commit("deleteCourse", {
              competenceCardId,
              courseId
            });
            resolve();
          }
        });
    });
  },
  batchAddCourse({ commit }, batchPayload) {
    return new Promise((resolve, reject) => {
      client
        .post(state.apiUrl + "/api/CompetenceCards/Courses", batchPayload)
        .then(response => {
          if (response && response.data) {
            commit("batchAddCourse", dataFormatter.deserialize(response.data));
            resolve(true);
          }
        })
        .catch(e => reject(e));
    });
  },
  setSortDirection({ commit }, { sortDirection }) {
    commit("setSortDirection", sortDirection);
  },
  setNameFilter({ commit }, name) {
    commit("setNameFilter", name);
  },
  setCompetenceFilter({ commit }, competence) {
    commit("setCompetenceFilter", competence);
  },
  setCourseFilter({ commit }, course) {
    commit("setCourseFilter", course);
  },
  setWorkplaceFilter({ commit }, workplace) {
    commit("setWorkplaceFilter", workplace);
  },
  setExpiringFilter({ commit }, expiring) {
    commit("setExpiringFilter", expiring);
  },
  resetAllFilters({ commit }) {
    commit("resetAllFilters");
  }
};

const mutations = {
  setAppData(state, { apiUrl }) {
    state.apiUrl = apiUrl;
  },
  setSettingsContext(state, settingsContext) {
    Vue.set(state, "settingsContext", settingsContext);
  },
  setCompetenceCards(state, competenceCards) {
    state.competenceCards = competenceCards;
  },
  addCompetenceCard(state, competenceCard) {
    state.competenceCards.push(competenceCard);
  },
  editCompetenceCard(state, { id, updated }) {
    let competenceCard = state.competenceCards.find(card => card.id === id);
    if (competenceCard) {
      // Redo the array with all cards without the updated card, which we then add to the end, then we sort it
      state.competenceCards = [
        ...state.competenceCards.filter(
          competenceCard => updated.id !== competenceCard.id
        ),
        updated
      ].sort((a, b) =>
        a.basicInformation &&
        b.basicInformation &&
        a.basicInformation.firstName > b.basicInformation.firstName
          ? 1
          : -1
      );
    }
  },
  deleteCompetenceCard(state, { id }) {
    Vue.delete(
      state.competenceCards,
      state.competenceCards.findIndex(card => card.id === id)
    );
  },
  /* --- Competences --- */
  addCompetence(state, { competenceCardId, competence }) {
    let competenceCard = state.competenceCards.find(
      card => card.id === competenceCardId
    );
    if (!competenceCard) return;
    if (!competenceCard.competences) Vue.set(competenceCard, "competences", []);

    competenceCard.competences.push(competence);
  },
  editCompetence(
    state,
    { competenceId, competenceCardId, level, note, printOption }
  ) {
    let competenceCard = state.competenceCards.find(
      card => card.id === competenceCardId
    );
    if (!competenceCard) return;
    let c = competenceCard.competences.find(
      competence => competence.id === competenceId
    );
    c.level = level;
    c.note = note;
    c.printOption = printOption;
  },
  deleteCompetence(state, { competenceCardId, competenceId }) {
    let competenceCard = state.competenceCards.find(
      card => card.id === competenceCardId
    );
    if (!competenceCard) return;
    competenceCard.competences.splice(
      competenceCard.competences.findIndex(
        competence => competence.id === competenceId
      ),
      1
    );
  },
  addCustomCompetence(state, competence) {
    console.log(competence);
    if (
      state.settingsContext.competences.find(
        _ => _.id.toLowerCase() === competence.id.toLowerCase()
      )
    ) {
      return;
    }
    state.settingsContext.competences.push({
      id: competence.id,
      group: competence.category,
      name: competence.name
    });
  },
  /* --- Courses --- */
  addCourse(state, { competenceCardId, course }) {
    let competenceCard = state.competenceCards.find(
      card => card.id === competenceCardId
    );
    if (!competenceCard) return;
    if (!competenceCard.courses) Vue.set(competenceCard, "courses", []);
    competenceCard.courses.push(course);
  },
  editCourse(state, { competenceCardId, courseId, updated }) {
    let competenceCard = state.competenceCards.find(
      card => card.id === competenceCardId
    );
    if (!competenceCard) return;
    let course = competenceCard.courses.find(course => course.id === courseId);
    if (!course) return;
    course.name = updated.name;
    course.category = updated.category;
    course.categoryGroup = updated.categoryGroup;
    course.courseType = updated.courseType;
    course.issuer = updated.issuer;
    course.issued = updated.issued;
    course.certificationLink = updated.certificationLink;
    course.expires = updated.expires;
    course.expirationHandleMode = updated.expirationHandleMode;
    course.status = updated.status;
    course.printOption = updated.printOption;
  },
  deleteCourse(state, { competenceCardId, courseId }) {
    let competenceCard = state.competenceCards.find(
      card => card.id === competenceCardId
    );
    if (!competenceCard || !competenceCard.courses) return;
    competenceCard.courses.splice(
      competenceCard.courses.findIndex(course => course.id === courseId),
      1
    );
  },
  addCourseCategory(state, category) {
    if (
      state.settingsContext.courseCategories.find(
        _ => _.id.toLowerCase() === category.id
      )
    ) {
      return;
    }

    state.settingsContext.courseCategories.push(category);
  },
  /* --- Batch Cources -- */
  batchAddCourse(state, batchCourses) {
    batchCourses.map(batch => {
      let competenceCard = state.competenceCards.find(
        card => card.id === batch.id
      );
      if (!competenceCard) return;
      if (!competenceCard.courses) Vue.set(competenceCard, "courses", []);
      competenceCard.courses.push(batch.course);
    });
  },
  setSortDirection(state, sortDirection) {
    Vue.set(state, "sortDirection", sortDirection);
  },
  setNameFilter(state, name) {
    Vue.set(state.appliedFilters, "name", name);
  },
  setCompetenceFilter(state, competence) {
    Vue.set(state.appliedFilters, "competence", competence);
  },
  setCourseFilter(state, course) {
    Vue.set(state.appliedFilters, "course", course);
  },
  setWorkplaceFilter(state, workplace) {
    Vue.set(state.appliedFilters, "workplace", workplace);
  },
  setExpiringFilter(state, expiring) {
    Vue.set(state.appliedFilters, "expiring", expiring);
  },
  resetAllFilters(state) {
    Vue.set(state, "appliedFilters", {});
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
